import { render, staticRenderFns } from "./DatosMedicos.vue?vue&type=template&id=fdd5233c&scoped=true"
import script from "./DatosMedicos.vue?vue&type=script&lang=js"
export * from "./DatosMedicos.vue?vue&type=script&lang=js"
import style0 from "./DatosMedicos.vue?vue&type=style&index=0&id=fdd5233c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd5233c",
  null
  
)

export default component.exports